import { Contract, ContractHelper } from '@ecm/portfolio';

export class TmsHelper {
    /**
     * Get mixed contracts for TMS (property `mixte_contrat`)
     * @param {Contract[]} contracts Contracts array from /portfolio API
     * @returns {string}
     */
    public static getMixedContracts(contracts: Contract[]): string {
        let mixedContracts = 'autre';
        let hasInternetOrange = false;
        let hasMobileOrange = false;
        let hasOpen = false;
        let hasLandline = false;
        let hasMobileSosh = false;
        let hasInternetSosh = false;

        if (contracts.length) {
            contracts
                .filter((contract: Contract) => contract.telco?.type && contract.telco?.state !== 'SUGGESTED')
                .filter((contract: Contract) => !['RESILIE', 'CLOS'].includes(contract.status))
                .forEach((contract: Contract) => {
                    if (contract.brand.toLowerCase() === 'orange') {
                        hasMobileOrange = hasMobileOrange || ContractHelper.isMobile(contract);
                        hasInternetOrange = hasInternetOrange || ContractHelper.isInternet(contract);
                        hasOpen = hasOpen || ContractHelper.isOpen(contract);
                        hasLandline = hasLandline || ContractHelper.isLandline(contract);
                    } else if (contract.brand.toLowerCase() === 'sosh') {
                        hasMobileSosh = hasMobileSosh || ContractHelper.isMobile(contract);
                        hasInternetSosh = hasInternetSosh || ContractHelper.isInternet(contract);
                    }
                });

            if (
                [hasMobileOrange, hasInternetOrange, hasOpen, hasLandline, hasMobileSosh, hasInternetSosh].filter(
                    (x) => x === true,
                ).length === 1
            ) {
                mixedContracts = 'mono';
            } else if (hasInternetOrange && hasMobileOrange) {
                mixedContracts = 'internet-mobile';
            } else if (hasOpen && hasMobileOrange) {
                mixedContracts = 'convergent-mobile';
            } else if (hasOpen && hasInternetOrange) {
                mixedContracts = 'convergent-internet';
            } else if (hasMobileSosh && hasInternetSosh) {
                mixedContracts = 'mobile-sosh-boite-sosh';
            } else if (hasOpen && hasMobileSosh) {
                mixedContracts = 'convergent-orange-mobile-sosh';
            } else if (hasMobileOrange && hasMobileSosh) {
                mixedContracts = 'mobile-orange-mobile-sosh';
            } else if (hasInternetOrange && hasMobileSosh) {
                mixedContracts = 'internet-orange-mobile-sosh';
            } else if (hasInternetOrange && hasInternetSosh) {
                mixedContracts = 'internet-orange-boite-sosh';
            } else if (hasOpen && hasInternetSosh) {
                mixedContracts = 'convergent-orange-boite-sosh';
            } else if (hasMobileOrange && hasInternetSosh) {
                mixedContracts = 'mobile-orange-boite-sosh';
            }
        }
        return mixedContracts;
    }

    /**
     * Get linked contracts for TMS (property `compte_rattaches`)
     * @param {Contract[]} contracts Contracts array from /portfolio API
     * @returns {string}
     */
    public static getLinkedContracts(contracts: Contract[]): string {
        const shortTypes = { internet: 'I', fixe: 'F', open: 'IM' };
        return contracts
            .filter((contract) => contract.telco?.type && contract.telco.state !== 'SUGGESTED')
            .map((contract): string => {
                const contractType = contract.telco.type.toLowerCase();
                return ContractHelper.isMobile(contract) ? 'M' : shortTypes[contractType] || '';
            })
            .filter((shortType) => shortType !== '')
            .join('+');
    }

    /**
     * format Label for trackLink by replacing accented characters and blank by "_"
     * @param {string} label
     * @returns {string}
     */
    public static getFormattedLabel(label: string): string {
        return label
            .toLowerCase()
            .replace(/ /g, '_')
            .replace(/[àâä]/g, 'a')
            .replace(/[ç]/g, 'c')
            .replace(/[èéêë]/g, 'e')
            .replace(/[îï]/g, 'i')
            .replace(/[ôö]/g, 'o')
            .replace(/[ùûü]/g, 'u');
    }
}
